(function () {
    'use strict';

    angular
        .module('app')
        /* @ngInject */
        .constant('MUSEO_FORM_ADMIN', function (modal) {
            var resolve = "$resolve.";
            if (modal) {
                resolve = "ctrl.resolve."
            }
            return {
                component: '<museo-form-admin ' +
                'item="' + resolve + 'item" ' +
                'previous-params="' + resolve + 'previousParams"' +
                '></museo-form-admin>',
                resolve: {
                    /* @ngInject */
                    item: function (Museo) {
                        return new Museo();
                    }
                }
            }
        });
})();
